export const STRINGS = {
  dismiss: 'Dismiss',
  loading: 'Loading',

  /** Web tab title + default native stack titles (React Navigation sets `document.title` on web). */
  appDocumentTitle: 'U.S.KidsGolf',

  supportEmail: 'coach@uskidsgolf.com',

  errors: {
    firestoreTimeout: 'Something went wrong. Please try again.',
    unexpectedErrorTitle: 'Something went wrong',
    unexpectedError:
      'The app encountered an unexpected error. Please try again, or contact support if the problem persists.',
    requestTimeoutTitle: 'Request Time-out',
    requestTimeoutMessage: 'Something went wrong. Please try again.',
    noInternetTitle: 'No internet connection',
    noInternetMessage: 'Check your internet connection and try again.',
    ok: 'OK',
  },

  /** Shared copy: tabs, reusable alerts, component fallbacks */
  common: {
    noPhone: 'No Phone',
    noAddress: 'No Address',
    navigation: {
      tabDashboard: 'Dashboard',
      tabPlayers: 'Players',
      tabPlayerPathway: 'Player Pathway',
    },
    noticeTitle: 'Notice',
    return: 'RETURN',
    buttons: {
      continue: 'Continue',
      dismiss: 'Dismiss',
    },
    playerPathwayScreen: {
      title: 'Player Pathway',
      signOut: 'Sign Out',
      buttons: {
        levels1to3: 'Levels 1-3',
        levels4to6: 'Levels 4-5',
        levels6to8: 'Levels 6-8',
        levels9to10: 'Levels 9-10',
      },
      noteRevision: 'Levels 6-10: ',
      noteRevision1: 'In revision.',
      sheet: {
        back: 'Back',
      },
      download: {
        errorTitle: 'Notice',
        errorMessage: 'Unable to download the file. Please try again.',
      },
    },
    alert: {
      info: 'Info',
      error: 'Error',
      success: 'Success',
      confirmTitle: 'Confirm',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    selectDefaultPlaceholder: 'Select',
    imageRenderError: 'Image render error',
    featureUnderProgress: 'This feature is under progress.',
    defaultCancel: {
      noticeTitle: 'Notice',
      dismiss: 'Dismiss',
      cancelMessage: 'Any changes you have made will be lost.',
      confirmDiscard: 'Continue',
      continueEditing: 'Cancel',
    },
    photoPermissionAlert: {
      title: 'Allow Access to Your Photos',
      message:
        'This lets you share from your camera roll, and enables other features for photos. Go to Settings and tap "Photos".',
      settings: 'Settings',
      notNow: 'Not now',
    },
  },

  auth: {
    enterEmail: {
      placeholderEmail: 'Enter your email',
      buttonNext: 'Next',
      alertTitle: 'Alert!',
      alertEmailNotApproved:
        'It looks like this email address has not been approved to use the Player Pathway yet. Please contact coach@uskidsgolf.com to check your status.',
      alertEmailNotVerified: 'The email address you entered is not valid. Please try again.',
      noticeTitle: 'Notice',
      errorCheckEmail: 'Please check your email',
      validationEmail: 'Please enter an email address verified by U.S. Kids Golf.',
      environmentPlaceholder: 'Select environment',
      environmentDevelopment: 'Develop',
      environmentProduction: 'Product',
    },
    enterPassword: {
      placeholderPassword: 'Enter password',
      buttonSignIn: 'Sign In',
      buttonForgotPassword: 'Forgot Password',
      buttonBack: 'Back',
      noticeTitle: 'Notice',
      errorPassword: 'Incorrect email/password combination. Please try again.',
      errorCurrentPassword: 'Incorrect current password. Please try again.',
      errorSignIn:
        'Something went wrong while signing you in. Please try again or contact support if the issue persists.',
    },
    forgotPassword: {
      title: 'Forgot Your Password?',
      description: 'Provide the email associated to your\nProgress Tracker Account:',
      validationEmail: 'Please enter a valid email.',
      placeholderEmail: 'Enter your email',
      buttonSendResetEmail: 'Send Reset Email',
      buttonCancel: 'Cancel',
      noticeTitle: 'Notice',
      alertTitle: 'Alert!',
      successMessage: 'Please check your email for next steps.',
      errorSendResetEmail: 'Something went wrong while sending the reset email. Please try again.',
    },
    verifyEmail: {
      title: 'Verify Your Email',
      description: 'Your email is not yet verified',
      buttonSendVerificationEmail: 'Send Verification Email',
      buttonCancel: 'Cancel',
      noticeTitle: 'Notice',
      successMessage:
        'We have sent a verification link to your email address.\nAfter verification, you can reset the password to start using the app.',
      errorSendVerificationEmail:
        'Something went wrong while sending the verification email. Please try again.',
    },
    loginCredentials: {
      title: 'Login Credentials',
      labelEmail: 'Email',
      labelPassword: 'Password',
      /** Visual mask only (not the real password length). */
      maskedPassword: '********',
      emailUnavailable: '—',
      buttonUpdatePassword: 'Update Password',
    },
    changePassword: {
      title: 'Change Password',
      sectionTitle: 'Setup Your Password',
      sectionDescription: 'This password is required to log into your Player Pathway app.',
      placeholderCurrent: 'Enter your current password',
      placeholderNew: 'Create a new password',
      placeholderConfirm: 'Confirm your new password',
      buttonUpdate: 'Update Password',
      buttonCancel: 'Cancel',
      successMessage: 'Your password has been changed!',
      cancelConfirmMessage: 'Any changes you have made will be lost.',
      validationMinLength: 'Password must include at least 8 characters',
      validationConfirmMismatch: 'Confirmation password does not match',
      errorSessionExpired: 'Session expired. Please sign in again.',
    },
    sessionTimeout: {
      title: 'Session Timeout',
      message: 'Your session has expired. Please log in again to continue using the app.',
      signIn: 'Sign In',
    },
  },

  drawer: {
    close: 'CLOSE',
    role: 'Coach',
    supportEmail: 'coaches@uskidsgolf.com',
    menu: {
      myCoachProfile: 'My Coach Profile',
      loginCredentials: 'Login Credentials',
      support: 'Support',
      logout: 'Logout',
    },
  },

  home: {
    header: {
      coachLabel: 'Coach',
    },
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
    },
    playerPathway: {
      body: 'Player Pathway Progress Tracker',
      buttonTrack: 'Track Progress Now',
      buttonResume: 'Resume Tracking Progress',
    },
  },

  player: {
    title: 'Player',
    profile: {
      ageYearsOld: 'years old',
      header: {
        back: 'BACK',
        title: 'PLAYER PROFILE',
        edit: 'EDIT',
      },
      tabs: {
        overview: 'Overview',
        progressTracker: 'Progress Tracker',
        notes: 'Notes',
        equipment: 'Equipment',
      },
      body: {
        progressTracker: 'Progress Tracker',
        notes: 'Notes',
        equipment: 'Equipment',
      },
      progressTrackerContent: {
        currentLevelTitle: 'CURRENT LEVEL',
        completedLevelsTitle: 'COMPLETED LEVELS',
        details: 'DETAILS',
        levelDetailsTitle: 'LEVEL DETAILS',
        lastClassAttendedLabel: 'Last Class Attended:',
        masteredLabel: 'Mastered',
        onLabel: 'On',
        masteredOnLabel: 'Mastered On',
        statusComplete: 'Complete',
        statusNotComplete: 'Not Complete',
        completedOnLabel: 'Completed on',
        incompleteAttemptOnLabel: 'Incomplete Attempt on',
        completed: 'Completed',
        incomplete: 'Incomplete',
        na: 'N/A',
        badgeTitles: {
          aroundTheGreen: 'Around The Green',
          fullSwing: 'Full Swing',
          scoring: 'Scoring',
          atg: 'ATG',
        },
        checkpointTitles: {
          forms: 'Forms',
          compass: 'Compass',
          combine: 'Combine',
        },
      },
      notesContent: {
        addNewNote: 'ADD NEW NOTE',
        details: 'DETAILS',
        detailsSheetTitle: 'NOTE DETAILS',
        newNoteTitle: 'NEW NOTE',
        saveSuccessMessage: 'Note added successfully!',
        alertTitle: 'Alert!',
        blankFieldsMessage: 'Information should not be blank.',
        titlePlaceholder: 'Note Title',
        detailPlaceholder: '',
        save: 'Save',
        cancel: 'Cancel',
        continue: 'Continue',
        saveProgressTitle: 'Save Progress',
        noticeTitle: 'Notice',
        saveProgressMessage: 'You are about to save this note. Are you sure you want to save it?',
        noticeMessage: 'Any changes you have made will be lost.',
        saveErrorTitle: 'Error',
        saveErrorMessage: 'Something went wrong while saving your note. Please try again.',
        saving: 'SAVING...',
      },
      overview: {
        actions: {
          call: 'Call',
          text: 'Text',
          email: 'Email',
        },
        contactInfoTitle: 'CONTACT INFO',
        labels: {
          parentName: 'PARENT NAME',
          phoneNumber: 'PHONE NUMBER',
          email: 'EMAIL',
        },
      },
      equipment: {
        title: 'Player Pathway Kit',
        showAll: 'Show All',
        add: 'ADD',
        addNewKit: 'Add new kit',
        sheetTitle: 'PLAYER PATHWAY KIT',
        addSheetTitle: 'ADD A NEW KIT',
        golfClubInfoTitle: 'Golf club info',
        details: 'DETAILS',
        kitLevelLabel: 'Kit Level:',
        kitLevelPlaceholder: 'Select Level',
        dateProvidedLabel: 'Date Provided:',
        saveChanges: 'SAVE CHANGES',
        noKits: 'No kits found',
        cancel: 'CANCEL',
        addKitSuccessMessage: 'A new KIT has been added successfully',
        kitLevel: (level: number) => `LEVEL ${level}`,
        by: 'by',
      },
    },
    filters: {
      back: 'Back',
      buttonDefault: 'Filter',
      buttonWithLevel: (level: number) => `: Level ${level}`,
      sheetTitle: 'Filter Results',
      sectionByLevel: 'By Level',
      sectionByLastActive: 'By Last Active',
      levelLabel: (level: number) => `Level ${level}`,
      lastActive: {
        oneMonth: '1 Month',
        twoMonths: '2 Months',
        threeMonths: '3 Months',
        sixMonths: '6 Months',
        oneHalfYears: '1.5 Years',
        showAll: 'Show All',
        noInactiveFilter: 'No Inactive Filter',
      },
      done: 'DONE',
    },
    sort: {
      back: 'Back',
      sheetTitle: 'Sort Results',
      sectionByFirstName: 'By First Name',
      sectionByLevel: 'By Level',
      sectionByAge: 'By Age',
      ascending: 'Ascending order',
      descending: 'Descending order',
      done: 'DONE',
      buttonName: 'Sort: Name',
      buttonLevel: 'Sort: Level',
      buttonAge: 'Sort: Age',
      buttonDefault: 'Sort',
    },
    listPlayers: {
      title: 'Search players',
      createProfileButton: 'Create a new profile',
      searchPlaceholder: 'Search for a player',
      filterButton: 'Filter',
      sortButton: 'Sort: Name',
      resultsSummaryTitleTablet: 'View Player Profile',
      emptyListMessage: 'No players found',
      loadingPlayers: 'Loading players...',
      // Marker may be appended by the backend while a player is being created.
      creatingPlayerMarker: '(CREATING PLAYER)',
      /** e.g. "5 Years Old" / "1 Year Old" — age number rendered separately */
      ageYearOld: 'Year Old',
      ageYearsOld: 'Years Old',
      resultsSummaryShowAll: (start: number, end: number, total: number) =>
        `${start}-${end} of ${total} Results`,
      resultsSummaryWithLastActive: (
        start: number,
        end: number,
        total: number,
        lastActiveLabel: string,
      ) => `${start}-${end} of ${total} Results Active in Last ${lastActiveLabel}`,
    },
    mutatePlayer: {
      header: {
        back: 'BACK',
        title: 'CREATE A PLAYER',
        editTitle: 'EDIT PLAYER',
      },
      levelTab: {
        tabProfile: 'Profile',
        tabLevel: 'Level',
        changeCurrentLevelTitle: 'CHANGE THE CURRENT PLAYER LEVEL',
        edit: 'EDIT',
        done: 'DONE',
        current: 'CURRENT',
        statusCompleted: 'COMPLETED',
        statusIncomplete: 'INCOMPLETE',
        /** Inline label next to level/skill rows (iOS-style). */
        statusPartial: 'PARTIAL',
        statusPartialCompletion: 'PARTIAL',
        clearData: `Clear data`,
        levelChangedHint:
          'You changed the current player level. Save these changes to continue to delete specific pathway data.',
        removeProgressTitle: 'Remove Progress',
        removeProgressMessage: (playerName: string) =>
          `You are about to permanently remove progress for ${playerName}. Would you like to proceed?`,
        removeProgressNo: 'No',
        removeProgressYes: 'Yes',
        removeProgressPlayerFallback: 'this player',
      },
      profile: {
        uploadPhoto: 'UPLOAD PHOTO',
        uploadPhotoHint: 'Image should not exceed 10MB',
        uploadPhotoUnsupportedTitle: 'Alert!',
        uploadPhotoUnsupportedMessage: (objectType: string) =>
          `${objectType} format is not supported`,
        uploadPhotoUnreadableMessage: 'Unable to load this image. Please try a different photo.',
        firstName: 'First Name',
        lastName: 'Last Name',
        birthDate: 'Birth Date',
        birthDatePlaceholder: '00/00/00',
        playerHeight: 'Player Height',
        playerHeightPlaceholder: '48"',
        playerGender: 'Player Gender',
        playerGenderPlaceholder: 'Unspecified',
        genderMale: 'Male',
        genderFemale: 'Female',
        level: 'Level',
        levelPlaceholder: 'Level 1',
        levelLabel: (level: number) => `Level ${level}`,
      },
      contact: {
        title: 'CONTACT INFO',
        parentFirstName: 'Parent First Name',
        parentLastName: 'Parent Last Name',
        phoneNumber: 'Phone Number',
        altPhoneNumber: 'Alt Phone Number',
        phonePlaceholder: '+1',
        email: 'Email',
        streetAddress: 'ADDRESS LINE 1',
        streetAddress2: 'ADDRESS LINE 2',
        streetAddressPlaceholder: 'Street Address',
        streetAddress2Placeholder: 'Apt, Suite, etc.',
        city: 'City',
        state: 'State',
        zipCode: 'Zip Code',
      },
      club: {
        title: 'CLUB INFO',
        needClubs: 'NEED CLUBS?',
        needClub: 'NEED CLUBS',
        dominantHand: 'DOMINANT HAND',
        yes: 'Yes',
        no: 'No',
        left: 'Left',
        right: 'Right',
      },
      footer: {
        saveChanges: 'SAVE CHANGES',
        save: 'SAVE',
        cancel: 'Cancel',
        deletePlayer: 'Delete Player',
        deleteConfirmMessage: 'Are you sure you want to delete this player?',
        deleteConfirmText: 'Delete',
        deleteWarningTitle: 'Warning',
        deleteWarningMessage: 'You have selected to delete this player. Are you sure?',
        playerRemovedTitle: 'Player Removed',
        playerRemovedMessage:
          'You have successfully deleted this player. The account can be restore by contacting your system admin.',
        return: 'Return',
        creatingLoading: 'Creating player...',
        updatingLoading: 'Updating player...',
        deletingLoading: 'Deleting player...',
        updateSuccessMessage:
          'Account details updated successfully! Changes will reflect momentarily.',
      },
      validation: {
        playerHeightMustBeNumber: 'Player height must be a number',
        phoneNumberDigitsRange: 'Phone number must be 9-24 digits',
        altPhoneNumberDigitsRange: 'Alt phone number must be 9-24 digits',
        birthDateRequired: 'Birth date is required',
        birthDateCannotBeFuture: 'Birth date cannot be in the future',
        fieldRequired: 'This field is required',
      },
    },
    profileLabel: 'Profile',
  },

  playerSession: {
    headerOverviewSession: {
      back: 'BACK',
      title: 'ACTIVE SESSION',
      end: 'END',
      trackingPlayers: (count: number) => `TRACKING ${count} PLAYER(S)`,
      noPlayers: 'No results found',
    },
    selectPlayers: {
      headerTitle: 'SELECT PLAYERS',
      back: 'BACK',
    },
    actions: {
      add: 'ADD',
      new: 'NEW',
      start: 'START',
      resume: 'RESUME',
      trackingSummary: (count: number) => `TRACKING ${count} PLAYER(S)`,
      selectedSummaryCount: (count: number) => `${count} PLAYER(S) SELECTED`,
    },
    sessionSummary: {
      title: 'SESSION SUMMARY',
      close: 'CLOSE',
      details: 'DETAILS',
      overview: 'OVERVIEW',
      emptyMessage: 'No attempts were made during this session.',
      noPinsMessage: 'No pins were earned during this session.',
    },
    stepDetail: {
      complete: 'COMPLETE',
      incomplete: 'INCOMPLETE',
      tryAgain: 'TRY AGAIN',
      skip: 'SKIP',
      unset: 'Unset',
      unsetAlertTitle: 'Alert!',
      unsetAlertBody:
        'You have attempted to unset player progress that has been saved from a previous session. Are you sure would like to proceed?',
      cancel: 'Cancel',
      skill1Label: 'Skill 1',
      skill2Label: 'Skill 2',
      pathwayNotesTitle: 'PATHWAY NOTES',
      pathwayNotesLevelHeader: (level: number) => `LEVEL ${level}: PLAYER PATHWAY`,
      skillCheckTitle: 'Skill Check',
      putYourFormsToWork: 'Put Your Forms to Work',
      instructionForms: 'Before moving to skills, review the forms.',
      instructionLink: 'Please see foundation.uskidsgolf.com/L1-3',
      instructionRevision: 'In Revision',
      incompleteTitle: (stepLabel: string) => `${stepLabel}: Incomplete`,
      incompleteBody: 'Great effort! Would you like to try again?',
      achievedTitle: (levelName: string, skillName: string, isTablet: boolean) =>
        isTablet
          ? `${levelName} ${skillName} Pin Achieved`
          : `${levelName} ${skillName}\nPin Achieved`,
      nextSkill: 'NEXT SKILL',
      levelCompleteTitle: (levelName: string, isTablet: boolean) =>
        isTablet
          ? `Congratulations! ${levelName} Complete!`
          : `Congratulations!\n${levelName} Complete!`,
      nextLevel: 'NEXT LEVEL',
      /** Max level (10): dismiss certificate and return to player overview. */
      levelCompleteBack: 'BACK',
    },
  },

  mutatePlayer: {
    validation: {
      playerHeightMustBeNumber: 'Player height must be a number',
      phoneNumberDigitsRange: 'Phone Number must be at least 10 characters',
      altPhoneNumberDigitsRange: 'Phone Number must be at least 10 characters',
      phoneNumberInvalid: 'Invalid Phone Number format',
      emailInvalid: 'Invalid Email format',
      avatarTooLarge: 'Your image exceeds 10MB. Please upload another image',
      zipCodeMustBeNumeric: 'ZIP Code must contain only digits',
      birthDateRequired: 'Birth date is required',
      birthDateCannotBeFuture: 'Birth date cannot be in the future',
      fieldRequired: 'This field is required',
    },
    footer: {
      noticeTitle: 'Notice',
      errorForm: 'Some required fields do not have correct information or are complete.',
      successMessage: 'Successfully created a new player!',
      dismiss: 'Dismiss',
      cancelMessage: 'Any changes you have made will be lost.',
      confirmDiscard: 'Continue',
      continueEditing: 'Cancel',
    },
  },

  mutateCoach: {
    title: 'Edit Profile',
    validation: {
      phoneNumberDigitsRange: 'Phone number must be 9-24 digits',
    },
    profile: {
      phoneNumber: 'Phone Number',
      streetAddress: 'ADDRESS LINE 1',
      streetAddress2: 'ADDRESS LINE 2',
      city: 'City',
      state: 'States',
      zipCode: 'Zip',
      streetAddressPlaceholder: 'Street Address',
      streetAddress2Placeholder: 'Apt, Suite, etc.',
      editContactInfo: 'EDIT CONTACT INFO',
    },
  },

  splash: {
    mandatoryRestart: {
      title: 'Restart Required',
      message:
        'A new update has just been downloaded. You need to restart the app to apply the new settings.',
      restartNow: 'Restart now',
    },
  },

  coachProfile: {
    header: {
      back: 'BACK',
      title: 'COACH PROFILE',
      edit: 'EDIT',
    },
    content: {
      address: 'ADDRESS',
      phoneNumber: 'Phone Number',
      email: 'Email',
      configInactiveFilter: 'The default inactive filter is',
      updateDefaultInactiveFilter: 'Update Default Inactive Filter',
      done: 'DONE',
    },
  },
} as const;
